
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.Container_9925d2cefb1bca9c{display:block;position:relative}.Input_ab8d3f464ed4f509{display:inline-block;box-sizing:border-box;width:100%;margin:0;font-size:18px;font-weight:500;line-height:22px;background-color:var(--backgroundColor_b6f17d28b8f3be5f)!important;border-style:solid;border-radius:var(--borderRadius_fb76152a28888f07);outline:none;box-shadow:none}.Input_ab8d3f464ed4f509.largeInput_0b668dbc7f0cf276{font-size:40px}.Input_ab8d3f464ed4f509::-moz-placeholder{visibility:hidden}.Input_ab8d3f464ed4f509:-ms-input-placeholder{visibility:hidden}.Input_ab8d3f464ed4f509::-ms-input-placeholder{visibility:hidden}.Input_ab8d3f464ed4f509::placeholder{visibility:hidden}.Input_ab8d3f464ed4f509:-webkit-autofill{background-color:transparent;text-shadow:none}.Label_7fea91e29471f3df{display:inline-block;position:absolute;left:0;right:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:300;transition-duration:.1s;transition-property:padding,line-height,font-size,color}.RightIcon_3bfc852d6c704145{display:none;position:absolute;right:0;margin:16px;width:24px;height:24px}.Messages_808bf6d0efa204fe{margin:8px 0 16px;font-size:14px;min-height:var(--showValidationSpacing_b3ff064acaa02996);line-height:18px;font-weight:300}.Input_ab8d3f464ed4f509{border-width:1px;padding:25px 16px 7px;border-color:var(--filledBorderColor_9b3fa1e409ee18d3);color:var(--filledInputColor_f1471ed80ec0be60);background-color:var(--filledBackgroundColor_e0dd72055ec0b3bb);caret-color:var(--caretColor_dbb2fec9854556f2)}.Input_ab8d3f464ed4f509.largeInput_0b668dbc7f0cf276{border-width:1px;padding:3px 16px}.Input_ab8d3f464ed4f509+.Label_7fea91e29471f3df{padding:8px 16px 0;font-size:12px;line-height:14px;color:var(--filledLabelColor_2ed6e5a431aa32c2)}.Input_ab8d3f464ed4f509~.Messages_808bf6d0efa204fe{color:var(--filledMessageColor_19cafd0d763bb162)}.Input_ab8d3f464ed4f509:placeholder-shown{color:var(--emptyInputColor_d02aa3c5fe9d2c3e);border-color:var(--emptyBorderColor_c9b5dd3d4c51c22d);background-color:var(--emptyBackgroundColor_f6632bd1a395faab)}.Input_ab8d3f464ed4f509:placeholder-shown+.Label_7fea91e29471f3df{padding:17px 16px;font-size:18px;line-height:22px;color:var(--emptyLabelColor_1f700c93f66e8863)}.Input_ab8d3f464ed4f509:placeholder-shown~.Messages_808bf6d0efa204fe{color:var(--emptyMessageColor_701de2e86e4e56f5)}.Input_ab8d3f464ed4f509.error_14d2de50d5a74051{border-width:2px;padding:24px 56px 6px 15px;border-color:var(--errorBorderColor_c37449ab80f37dda);color:var(--errorInputColor_4fb89d1e94d1d069);background-color:var(--errorBackgroundColor_5af51cb2e55e47c0)}.Input_ab8d3f464ed4f509.error_14d2de50d5a74051.largeInput_0b668dbc7f0cf276{padding:2px 56px 2px 15px}.Input_ab8d3f464ed4f509.error_14d2de50d5a74051+.Label_7fea91e29471f3df{padding-right:56px;color:var(--errorLabelColor_f84159bcdddeabe7)}.Input_ab8d3f464ed4f509.error_14d2de50d5a74051~.Messages_808bf6d0efa204fe{color:var(--errorMessageColor_261b9b1a020230e3)}.Input_ab8d3f464ed4f509.error_14d2de50d5a74051~.RightIcon_3bfc852d6c704145{display:inline-block;color:var(--errorIconColor_092e161af06365ff)}.Input_ab8d3f464ed4f509:focus{border-width:2px;padding:24px 15px 6px;border-color:var(--focusedBorderColor_2877e80e99f499f4);color:var(--focusedInputColor_8c1d299ba5c2452a);background-color:var(--focusedBackgroundColor_c5cfbb228de66baa)}.Input_ab8d3f464ed4f509.largeInput_0b668dbc7f0cf276:focus{padding:2px 15px}.Input_ab8d3f464ed4f509:focus+.Label_7fea91e29471f3df{padding:8px 16px 0;font-size:12px;line-height:14px;color:var(--focusedLabelColor_c93edd43474d2620)}.Input_ab8d3f464ed4f509:focus~.Messages_808bf6d0efa204fe{color:var(--focusedMessageColor_14c402f2e184eab0)}.Input_ab8d3f464ed4f509:focus~.RightIcon_3bfc852d6c704145{display:none}.Input_ab8d3f464ed4f509.warn_574d7a36c123d7d7{border-color:var(--warnBorderColor_583bf8ca0960905e);color:var(--warnInputColor_cc61feca9f866e9e);background-color:var(--warnBackgroundColor_3fa79ab6cf734cb7)}.Input_ab8d3f464ed4f509.warn_574d7a36c123d7d7+.Label_7fea91e29471f3df{color:var(--warnLabelColor_20f64f852b725dad)}.Input_ab8d3f464ed4f509.warn_574d7a36c123d7d7~.Messages_808bf6d0efa204fe{color:var(--warnMessageColor_6a7cc0d157a06b38)}.Input_ab8d3f464ed4f509.readonly_676162b428a857ac{border-width:1px;padding:25px 56px 7px 16px;border-color:var(--readonlyBorderColor_1f2bcaa3c65a8525);color:var(--readonlyInputColor_3b7dea93e49321a4);background-color:var(--readonlyBackgroundColor_2f06804865077658)}.Input_ab8d3f464ed4f509.readonly_676162b428a857ac+.Label_7fea91e29471f3df{padding:8px 16px 0;font-size:12px;line-height:14px;color:var(--readonlyLabelColor_2f106aaee0c90cda)}.Input_ab8d3f464ed4f509.readonly_676162b428a857ac~.Messages_808bf6d0efa204fe{color:var(--readonlyMessageColor_3b7c34a538ebe7c3)}.Input_ab8d3f464ed4f509.readonly_676162b428a857ac~.RightIcon_3bfc852d6c704145{display:inline-block;color:var(--readonlyIconColor_6ab6aaf1774c0e37)}`;
styleInject(_css)

/** Container Props */
export type ContainerCCM = {
  /** Container Component Custom Properties */
  // No custom properties found

  /** Container Modifier Flags */
  // No modifiers classes found
};
/** Base Container component */
export const Container: ComponentCreator<ContainerCCM> = createComponentCreator({
  "name": "Container",
  "base": "Container_9925d2cefb1bca9c",
  "prop": {},
  "mod": {}
});


/** Input Props */
export type InputCCM = {
  /** Input Component Custom Properties */
  '$backgroundColor': string;
  '$borderRadius': string;
  '$filledBorderColor': string;
  '$filledInputColor': string;
  '$filledBackgroundColor': string;
  '$caretColor': string;
  '$emptyInputColor': string;
  '$emptyBorderColor': string;
  '$emptyBackgroundColor': string;
  '$errorBorderColor': string;
  '$errorInputColor': string;
  '$errorBackgroundColor': string;
  '$focusedBorderColor': string;
  '$focusedInputColor': string;
  '$focusedBackgroundColor': string;
  '$warnBorderColor': string;
  '$warnInputColor': string;
  '$warnBackgroundColor': string;
  '$readonlyBorderColor': string;
  '$readonlyInputColor': string;
  '$readonlyBackgroundColor': string;

  /** Input Modifier Flags */
  '$largeInput'?: boolean;
  '$error'?: boolean;
  '$warn'?: boolean;
  '$readonly'?: boolean;
};
/** Base Input component */
export const Input: ComponentCreator<InputCCM> = createComponentCreator({
  "name": "Input",
  "base": "Input_ab8d3f464ed4f509",
  "prop": {
    "$backgroundColor": "--backgroundColor_b6f17d28b8f3be5f",
    "$borderRadius": "--borderRadius_fb76152a28888f07",
    "$filledBorderColor": "--filledBorderColor_9b3fa1e409ee18d3",
    "$filledInputColor": "--filledInputColor_f1471ed80ec0be60",
    "$filledBackgroundColor": "--filledBackgroundColor_e0dd72055ec0b3bb",
    "$caretColor": "--caretColor_dbb2fec9854556f2",
    "$emptyInputColor": "--emptyInputColor_d02aa3c5fe9d2c3e",
    "$emptyBorderColor": "--emptyBorderColor_c9b5dd3d4c51c22d",
    "$emptyBackgroundColor": "--emptyBackgroundColor_f6632bd1a395faab",
    "$errorBorderColor": "--errorBorderColor_c37449ab80f37dda",
    "$errorInputColor": "--errorInputColor_4fb89d1e94d1d069",
    "$errorBackgroundColor": "--errorBackgroundColor_5af51cb2e55e47c0",
    "$focusedBorderColor": "--focusedBorderColor_2877e80e99f499f4",
    "$focusedInputColor": "--focusedInputColor_8c1d299ba5c2452a",
    "$focusedBackgroundColor": "--focusedBackgroundColor_c5cfbb228de66baa",
    "$warnBorderColor": "--warnBorderColor_583bf8ca0960905e",
    "$warnInputColor": "--warnInputColor_cc61feca9f866e9e",
    "$warnBackgroundColor": "--warnBackgroundColor_3fa79ab6cf734cb7",
    "$readonlyBorderColor": "--readonlyBorderColor_1f2bcaa3c65a8525",
    "$readonlyInputColor": "--readonlyInputColor_3b7dea93e49321a4",
    "$readonlyBackgroundColor": "--readonlyBackgroundColor_2f06804865077658"
  },
  "mod": {
    "$largeInput": "largeInput_0b668dbc7f0cf276",
    "$error": "error_14d2de50d5a74051",
    "$warn": "warn_574d7a36c123d7d7",
    "$readonly": "readonly_676162b428a857ac"
  }
});


/** Label Props */
export type LabelCCM = {
  /** Label Component Custom Properties */
  '$filledLabelColor': string;
  '$emptyLabelColor': string;
  '$errorLabelColor': string;
  '$focusedLabelColor': string;
  '$warnLabelColor': string;
  '$readonlyLabelColor': string;

  /** Label Modifier Flags */
  // No modifiers classes found
};
/** Base Label component */
export const Label: ComponentCreator<LabelCCM> = createComponentCreator({
  "name": "Label",
  "base": "Label_7fea91e29471f3df",
  "prop": {
    "$filledLabelColor": "--filledLabelColor_2ed6e5a431aa32c2",
    "$emptyLabelColor": "--emptyLabelColor_1f700c93f66e8863",
    "$errorLabelColor": "--errorLabelColor_f84159bcdddeabe7",
    "$focusedLabelColor": "--focusedLabelColor_c93edd43474d2620",
    "$warnLabelColor": "--warnLabelColor_20f64f852b725dad",
    "$readonlyLabelColor": "--readonlyLabelColor_2f106aaee0c90cda"
  },
  "mod": {}
});


/** RightIcon Props */
export type RightIconCCM = {
  /** RightIcon Component Custom Properties */
  '$errorIconColor': string;
  '$readonlyIconColor': string;

  /** RightIcon Modifier Flags */
  // No modifiers classes found
};
/** Base RightIcon component */
export const RightIcon: ComponentCreator<RightIconCCM> = createComponentCreator({
  "name": "RightIcon",
  "base": "RightIcon_3bfc852d6c704145",
  "prop": {
    "$errorIconColor": "--errorIconColor_092e161af06365ff",
    "$readonlyIconColor": "--readonlyIconColor_6ab6aaf1774c0e37"
  },
  "mod": {}
});


/** Messages Props */
export type MessagesCCM = {
  /** Messages Component Custom Properties */
  '$showValidationSpacing': string;
  '$filledMessageColor': string;
  '$emptyMessageColor': string;
  '$errorMessageColor': string;
  '$focusedMessageColor': string;
  '$warnMessageColor': string;
  '$readonlyMessageColor': string;

  /** Messages Modifier Flags */
  // No modifiers classes found
};
/** Base Messages component */
export const Messages: ComponentCreator<MessagesCCM> = createComponentCreator({
  "name": "Messages",
  "base": "Messages_808bf6d0efa204fe",
  "prop": {
    "$showValidationSpacing": "--showValidationSpacing_b3ff064acaa02996",
    "$filledMessageColor": "--filledMessageColor_19cafd0d763bb162",
    "$emptyMessageColor": "--emptyMessageColor_701de2e86e4e56f5",
    "$errorMessageColor": "--errorMessageColor_261b9b1a020230e3",
    "$focusedMessageColor": "--focusedMessageColor_14c402f2e184eab0",
    "$warnMessageColor": "--warnMessageColor_6a7cc0d157a06b38",
    "$readonlyMessageColor": "--readonlyMessageColor_3b7c34a538ebe7c3"
  },
  "mod": {}
});

